<template>
  <div
    class="addUser"
    ref="addUser"
  >
    <a-modal
      class=""
      title="新增"
      width="550px"
      :centered="true"
      v-model:visible="visible"
      :getContainer="()=>$refs.addUser"
      cancelText="取消"
      okText="确定"
      @ok="add"
    >
      <a-form
        :label-col="labelCol"
        :model="formState"
      >
        <a-form-item
          label="	设备UUID"
          class="ipt"
        >
          <a-select
            class="a-select"
            v-model:value="formState.deviceUuid"
          >
            <a-select-option
              v-for="(item, i) in uuidList"
              :value="item"
            >{{item}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="时间规则"
          class="ipt"
        >
          <a-select
            class="a-select"
            v-model:value="formState.timeRule"
          >
            <a-select-option
              v-for="(item, i) in timeRuleList"
              :value="item.value"
            >{{item.rule}}</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
// @ is an alias to /src
import { addIotDataReportRuleConf } from "@/api/warning/warning.js";

export default {
  name: "AddSet",
  data() {
    return {
      visible: false,
      labelCol: {
        span: 4
      },
      formState: {
        deviceUuid: '',
        timeRule: '',
      },
      uuidList: [],
      timeRuleList: [
        {
          value: 1,
          rule: '1天'
        },
        {
          value: 2,
          rule: '2天'
        },
        {
          value: 3,
          rule: '3天'
        },
        {
          value: 4,
          rule: '4天'
        },
        {
          value: 5,
          rule: '5天'
        },
        {
          value: 6,
          rule: '6天'
        },
        {
          value: 7,
          rule: '7天'
        },
        {
          value: 8,
          rule: '半个月内'
        },
        {
          value: 9,
          rule: '一个月内'
        },
        {
          value: 10,
          rule: '三个月内'
        },
        {
          value: 11,
          rule: '半年内'
        },
        {
          value: 12,
          rule: '一年内'
        },
      ]
    }
  },
  methods: {
    show(uuidList) {
      console.log(uuidList)
      this.uuidList = uuidList
      this.visible = true
    },
    hide() {
      this.visible = false
    },
    add() {
      // console.log(this.formState)
      addIotDataReportRuleConf(this.formState).then(res => {
        if (res.code == 200) {
          this.$message.success(res.data);
          this.$emit('confirm')
          this.hide()
        }
      }).catch(res => {
        console.log(res)
      });
    }
  }
};
</script>
<style scoped>
.addUser :deep() .ant-modal-title {
  padding-left: 10px;
  margin-top: 20px;
  vertical-align: top;
  font-size: 20px;
  line-height: 1;
  font-weight: 600;
  color: #222222;
  border-left: 5px solid #0088ff;
}
.ant-modal-header {
  border: 0;
}
.addUser :deep() .ant-modal-body {
  padding: 24px 50px;
}
.addUser :deep() .ant-form-item-label > label {
  height: 40px;
}
.ipt input {
  width: 343px;
  height: 40px;
  background: #fefefe;
  border: 1px solid #dddddd;
  border-radius: 6px;
}
.ipt :deep() .ant-cascader-input.ant-input {
  width: 343px;
  height: 40px;
  line-height: 36px;
  background: #fefefe;
  border: 1px solid #ddd;
  border-radius: 6px;
}
.ipt :deep() .ant-form-item .ant-cascader-picker {
  width: 343px;
}
.a-select {
  width: 343px;
}
.a-select :deep() .ant-select-selector {
  width: 343px;
  height: 40px;
  border-radius: 6px;
}
.a-select :deep() .ant-select-selection-item {
  line-height: 38px;
}
.addUser :deep() .ant-form-item-control-input {
  width: 343px;
  height: 40px;
}
.addUser :deep() .ant-btn:nth-child(1) {
  width: 110px;
  height: 40px;
  color: #0088ff;
  border: 1px solid #0088ff;
  border-radius: 6px;
}
.addUser :deep() .ant-btn-primary {
  width: 110px;
  height: 40px;
  margin: 10px 0 10px 20px;
  background: linear-gradient(-30deg, #0077ee, #33aaff);
  border-radius: 6px;
}
.addUser .del2 :deep() .ant-modal-header {
  display: none;
}
</style>
